import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceAddPage {
    lookupService = new APIServiceLookUp();

    async getAllAddPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}addPage/getAllAddPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAddPageById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}addPage/getAddPageById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateAddPagePage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}addPage/updateAddPagePage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setAddPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}addPage/setAddPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delAddPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}addPage/delAddPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}
